import { Card, Table, Button, Spinner, } from "react-bootstrap";
import { FileEarmark } from "react-bootstrap-icons";
import { formatCurrency } from "../../../store/config";
import StatusBadge from "./StatusBadge";
import PaginationComponent from "./PaginationComponent";
import { useWithdrawalRequests } from "../../hooks/useWithdrawalRequest";
import { useWithdrawalActions } from "../../hooks/useWithdrawalActions";
import WithdrawalFilters from "./WithdrawalFilter";
import MembershipRequestDetailsModal from "./MembershipRequestModal";
import CommentsModal from "./CommentModal";
import ContentWrapper from "../../utilities/ContentWrapper";

function MembershipWithdrawalManagement() {
    const {
        withdrawalRequests,
        isLoading,
        pagination,
        filterStatus,
        searchQuery,
        currentPage,
        setSearchQuery,
        handleFilterChange,
        handleSearch,
        handlePageChange,
        resetFilters,

    } = useWithdrawalRequests("membership");

    const {
        selectedRequest,
        showDetailsModal,
        showCommentsModal,
        processingAction,
        comments,
        transactionReference,
        setComments,
        setShowCommentsModal,
        setTransactionReference,
        handleViewDetails,
        handleUpdateStatus,
        closeModals,

    } = useWithdrawalActions("membership");

    const statusBadgeElement = (status) => <StatusBadge status={status} />;

    const updateRequestStatus = (status) => {
        handleUpdateStatus(status);
    };


    return (
        <ContentWrapper>
            {/* Filters */}
            <Card className="mb-4 shadow-sm">
                <Card.Body>
                    <WithdrawalFilters
                        filterStatus={filterStatus}
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        handleFilterChange={handleFilterChange}
                        handleSearch={handleSearch}
                        resetFilters={resetFilters}
                    />
                </Card.Body>
            </Card>

            {/* Withdrawal requests table */}
            <Card className="shadow-sm">
                <Card.Body className="p-0">
                    {isLoading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-3">Loading withdrawal requests...</p>
                        </div>
                    ) : withdrawalRequests?.length === 0 ? (
                        <div className="text-center py-5">
                            <FileEarmark size={48} className="text-muted mb-3" />
                            <h5>No withdrawal requests found</h5>
                            <p className="text-muted">No requests match your current filters</p>
                        </div>
                    ) : (
                        <>
                            <Table responsive hover className="mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Date</th>
                                        <th>Member ID</th>
                                        <th>Name</th>
                                        <th>Effective Date</th>
                                        <th className="text-right">Amount Due</th>
                                        <th className="text-center">Status</th>
                                        <th className="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {withdrawalRequests.map((request) => (
                                        <tr key={request._id}>
                                            <td>{new Date(request.createdAt || request.requestDate).toLocaleDateString()}</td>
                                            <td>{request.memberId || request.userId}</td>
                                            <td>{request.personalInfo?.fullName || "N/A"}</td>
                                            <td>
                                                {request.withdrawalDetails?.effectiveDate ?
                                                    new Date(request.withdrawalDetails.effectiveDate).toLocaleDateString() :
                                                    "N/A"}
                                            </td>
                                            <td className="text-right">
                                                {formatCurrency(request.withdrawalDetails?.amountDue || 0)}
                                            </td>
                                            <td className="text-center">
                                                {statusBadgeElement(request.status)}
                                            </td>
                                            <td className="text-center">
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => handleViewDetails(request)}
                                                >
                                                    View Details
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <PaginationComponent
                                pagination={pagination}
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                            />
                        </>
                    )}
                </Card.Body>
            </Card>

            {/* Modals */}
            {selectedRequest && (
                <>
                    <MembershipRequestDetailsModal
                        show={showDetailsModal}
                        onHide={closeModals}
                        request={selectedRequest}
                        processingAction={processingAction}
                        transactionReference={transactionReference}
                        setTransactionReference={setTransactionReference}
                        handleUpdateStatus={handleUpdateStatus}
                        StatusBadge={StatusBadge}
                    />

                    <CommentsModal
                        show={showCommentsModal}
                        onHide={() => setShowCommentsModal(false)}
                        comments={comments}
                        setComments={setComments}
                        processingAction={processingAction}
                        onConfirm={() => updateRequestStatus("rejected")}
                    />
                </>
            )}
        </ContentWrapper>
    );
}

export default MembershipWithdrawalManagement;